import React, { useEffect } from "react";
//import Scss
import "./assets/scss/themes.scss";
//import Route
import Route from "./routes";
import { getAppConfig } from "config/configInitializer";

function App() {
  useEffect(() => {
    try {
      const config = getAppConfig();
      document.title = config.siteTitle;
    } catch (err) {
      console.error("App config could not be loaded:", err);
    }
  }, []);

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
